import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"
import Select from "react-select"

export default function FormCounter({submit, isNew, inputChange, state, farms}) {
    const { t } = useTranslation()

    const [farmsOptions, setFarms] = useState([])

    useEffect(()=>{
        let farmsToUse = []
        let optionSelected = null

        farms?.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            farmsToUse.push(object)

            if (state?.farm?._id !== undefined || state?.farmEdit?._id !== undefined) {
                if (state?.farm?._id === farm._id || state?.farmEdit?._id === farm._id) {
                    optionSelected = object
                }
            } else {
                if (state?.farm === farm._id || state?.farmEdit === farm._id) {
                    optionSelected = object
                }
            }
        })

        setFarms({options: farmsToUse, selected: optionSelected})
    }, [farms, state.farm, state.farmEdit])

    const handleSelectFarmChange = (e) => {
        inputChange({target:{name: 'farm', value: e.value}})
    }

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('counters.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('counters.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('counters.description')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='description' 
                        value={state.description || state.descriptionEdit ||  ''}
                        placeholder={t('counters.description')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('counters.farm')}</Form.Label>
                    <Select onChange={handleSelectFarmChange}
                        name="farm"
                        placeholder={t('counters.farm')}
                        options={farmsOptions.options}
                        value={farmsOptions.selected}
                    />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('counters.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('counters.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
